import { useEffect, useRef, useState } from 'react';
import { StyledBouncingStar } from './BouncingStar.styled';

export default function BouncingStar({ stars }) {
  const lastStars = useRef(null);
  const [bounceKey, setBounceKey] = useState(0);

  useEffect(() => {
    if (lastStars.current != null && lastStars.current != stars) {
      setBounceKey((prev) => prev + 1);
    }
    lastStars.current = stars;
  }, [stars]);

  return (
    <StyledBouncingStar
      key={bounceKey}
      className={bounceKey > 0 ? 'bounce' : ''}
    >
      ⭐️
    </StyledBouncingStar>
  );
}
